import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { assignById } from "@insite/client-framework/Store/Data/DataState";
import { BillToCollectionModel, BillToModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { GetCustomBillTosApiParameter } from "@WhiteCap/Services/CustomCustomerService";
import { Draft } from "immer";

export interface CustomBillTosState {
    readonly isLoading: boolean;
    readonly billTos: BillToModel[];
    readonly pagination?: PaginationModel | null;
    readonly customerNumber?: string;
}

const initialState: CustomBillTosState = {
    isLoading: false,
    billTos: [],
    pagination: undefined,
    customerNumber: "",
};

const reducer = {
    "Custom/BillTosWithAccounts/BeginLoad": (draft: Draft<CustomBillTosState>) => {
        draft.isLoading = true;
    },
    "Custom/BillTosWithAccounts/CompleteLoad": (
        draft: Draft<CustomBillTosState>,
        action: { collection: BillToCollectionModel; parameter: GetCustomBillTosApiParameter },
    ) => {
        draft.isLoading = false;
        draft.billTos = action.collection.billTos ?? [];
        draft.pagination = action?.collection?.pagination;
        if (!action.parameter.additionalExpands?.includes("accounts")) {
            draft.customerNumber = action.parameter.customerNumber;
        }
    },
    "CustomBillTos/CompleteLoadBillTo": (
        draft: Draft<CustomBillTosState>,
        action: { model: BillToModel; isCurrent?: boolean },
    ) => {
        const index = draft.billTos.findIndex(b => b.id === action.model.id);
        if (index >= 0) {
            draft.billTos[index] = action.model;
        } else {
            draft.billTos.push(action.model);
        }
        if (action.isCurrent) {
            draft.customerNumber = action.model.id;
        }
    },
    "Custom/BillTosWithAccounts/Reset": () => {
        return initialState;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
